import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { FiProfileSizes, IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { fiTextToHtml } from '@fi-shared/utils/fi-text-to-html';

export enum TextFontSize {
    FontSize16px,
    FontSize14px,
    FontSize12px,
}

@Component({
    selector: 'fi-select-search-item',
    template: `
        @if (profilePictureIcon) {
          <fi-profile-icon
            [profileData]="profileData"
            [size]="profilePictureSize"
            [profilePictureIcon]="profilePictureIcon"
            [isRegularMatIcon]="isRegularMatIcon"
            [isRound]="isRound"
            >
          </fi-profile-icon>
        }
        <div class="select-search-item-name-container">
          <span
            class="select-search-item-name"
            [ngClass]="getMainSearchItemNameClass()"
            [innerHTML]="getSafeHtml(name) | highlight: getSafeHtml(searchText)"
            >
          </span>
          @if (additionalName) {
            <span
              class="select-search-item-name additional"
              [ngClass]="getFontSizeClass(additionalTextFontSize)"
              [innerHTML]="getSafeHtml(additionalName) | highlight: getSafeHtml(searchText)"
              >
            </span>
          }
        </div>
        @if (isOptionWarningTextDisplayed) {
          <div class="select-search-item-warning-text-wrapper">
            <span class="select-search-item-warning-text">{{ optionWarningText }}</span>
          </div>
        }
        `,
    styleUrls: ['./fi-select-search-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-select-search-item' },
    standalone: false,
})
export class FiSelectSearchItemComponent {
    @Input() name: string;
    @HostBinding('class.double-string') @Input() additionalName: string;
    @Input() profilePicture: string;
    @Input() profilePictureIcon: string;
    @Input() profilePictureSize: FiProfileSizes;
    @Input() isRound: boolean = true;
    @Input() searchText: string;
    @Input() mainTextFontSize: TextFontSize = TextFontSize.FontSize16px;
    @Input() additionalTextFontSize: TextFontSize = TextFontSize.FontSize16px;
    @Input() profileData: IUserProfile;
    @Input() isOptionWarningTextDisplayed: boolean;
    @Input() optionWarningText: string;
    @Input() optionTextClass: string;
    @Input() isRegularMatIcon: boolean = false;

    getMainSearchItemNameClass(): string {
        return `${this.getFontSizeClass(this.mainTextFontSize)} ${this.optionTextClass}`;
    }

    getFontSizeClass(fontSizeValue: TextFontSize): string {
        return `size-${TextFontSize[fontSizeValue]}`;
    }

    getSafeHtml(str: string) {
        return fiTextToHtml(str);
    }
}
